import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import MaterialTable from 'material-table';
import { Badge, Paper, FormControlLabel, FormControl, Checkbox, TextField, Button, Select, OutlinedInput } from '@material-ui/core'; 
import { DeleteOutlineOutlined as DeleteIcon, LocalShipping as TruckCartIcon, Sync as SyncIcon, AttachFile, Search as SearchIcon, Clear as ClearIcon } from '@material-ui/icons';

import style from './forwarderExport.module.css';
import awbActionStyle from '../gha/manageOrders/pickupOrderAwbsList/poAwbList.module.css';
import commonStyles from '../common/common.module.css';
import orderNumberSearchStyles from '../common/orderNumberSearch.module.css';
import forwarderStyles from '../forwarderHeader/forwarderHeader.module.css';

import Awb from '../../models/Awb';
import { UserRoleType } from '../../models/User';

import Moment from 'moment';

import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

const iconFontSize = 20;
const PADDING_RIGHT = '14px';

const sortArr = [
  {
    value: 'creation_date',
    label:'Order Creation Date'
  },
  {
    value: 'arrival_date',
    label: 'Latest Arrival Date'
  },
  {
    value: 'prefix',
    label: 'Airwaybill Prefix'
  }
]

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      color: 'rgb(204, 204, 204)'
    },
    awbFilters: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  });

interface ForwarderExportProps {
  classes: any;
  awbs: Awb[];
  openParts: (awb: Awb) => void;
  deleteAwb: (awbCode: string, awbNumber: string) => void;
  onSyncClick: (awbCode: string, awbNumber: string) => void;
  enableCartIcon: (awbCode: string, awbNumber: string) => boolean;
  checkAirwayBillIsInTheCart: (awbCode: string, awbNumber: string, ver: number) => void;
  openAttachments: (awbCode: string, awbNumber: string, version: number) => void;
  handleOpenPoD: (code: string, number: string, version: number) => void;
  userRole: UserRoleType;
  isMeEditMode: boolean;
  completed: boolean;
  completeAwbs: () => void;
  awbNumber: string;
  searchAwb: Function;
  onChange: Function;
  sortValue: string;
  clearAwb: Function;
};

const forwarderExport = (props: ForwarderExportProps) => {

  const { classes } = props;
  let textFieldClass: string = '';
  const sortOptions: Array<JSX.Element> = sortArr.map((val: {value: string, label: string} , index: number) => (
    <option key={ index } value={ val.value }>{ val.label }</option>
  ));

  return (
    <div className={ `${ commonStyles.wrapper } ${ awbActionStyle.wrapper }` }>
      <h3 className={commonStyles.header}> Awbs</h3>
      {props.userRole == UserRoleType.FORWARDER && <div className={classes.awbFilters}>
        <div>
          <small className={commonStyles.pr1}>Hide:</small>
          <FormControlLabel
            value=""
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary" />}
                checkedIcon={<CheckBoxIcon color="primary" />}
                classes={{
                  root: classes.checkbox,
                }}
                onChange={props.completeAwbs}
                checked={props.completed}
              />
            }
            label={'Delivered'}
            className={classes.completeLabel}
          />
        </div>

        <div className={[orderNumberSearchStyles.textField, orderNumberSearchStyles.flexAndRow, orderNumberSearchStyles.justContentSpaceBetween, forwarderStyles.fwdSearchField, commonStyles.positionRelative].join(' ')} >
          <TextField
            value={props.awbNumber}
            variant="outlined"
            onChange={(e) => props.onChange('awb', e)}
            className={commonStyles.searchWrapper}
            InputProps={{
              className: [textFieldClass, commonStyles.searchIpField].join(' '),
              classes: { input: classes.inputSize }
            }}
            InputLabelProps={{ className: [textFieldClass, classes.textFieldLabel].join(' ') }}
            placeholder='Search AWB'
          />

          <Button
            color="primary"
            variant="contained"
            onClick={() => props.searchAwb()}
            className={commonStyles.searchBtn}

          >
            <SearchIcon
              className={`${commonStyles.iconSearch} ${commonStyles.mb3}`} />
          </Button>
          {props.awbNumber && <Button
            color="primary"
            variant="contained"
            onClick={() => props.clearAwb()}
            className={commonStyles.cancelBtn}

          >
            <ClearIcon
              className={`${commonStyles.iconSearch} ${commonStyles.mb3}`} />
          </Button>}
        </div>

        <div className={commonStyles.dFlex}>
          <div>
            <small className={commonStyles.pr1}>Sort List By: </small>
            <FormControl className={forwarderStyles.formControl} >
              <Select native
                onChange={(e) => props.onChange('sort', e)}
                value={props.sortValue}
                inputProps={{
                  name: 'port',
                  id: 'port',
                }}
                className={forwarderStyles.selectIp}
                input={<OutlinedInput labelWidth={0} />}
              >
                {sortOptions}
              </Select>
            </FormControl>
          </div>
        </div>
      </div>}

      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
        
        columns = {[
          { title: 'Airwaybill', field: '', cellStyle: { cursor: 'pointer', color: '#003261', textDecoration: 'underline', paddingRight: PADDING_RIGHT, width:'110px' },
            render: (rowData: Awb) => {

              return <span onClick= { () => { props.openParts(rowData) } }>{ rowData.code }-{ rowData.number }</span>;
            }
          },
          { title: 'Destination', field: 'destination', cellStyle: { paddingRight: PADDING_RIGHT, paddingLeft: '5px' }, headerStyle: { paddingRight: PADDING_RIGHT, paddingLeft: '5px' } },
          { title: 'Flight', field: '', cellStyle: { cursor: 'pointer', color: '#003261', textDecoration: 'underline', paddingRight: PADDING_RIGHT},
            render: (rowData: Awb) => { 
              
              const flightDate: string = rowData.export_parts[0] ? Moment(rowData.export_parts[0].flight_date).format('DDMMMYY').toUpperCase() : '';
              const flightNumber: string = rowData.export_parts.length > 1 ? 'PART SHIPMENT' : rowData.export_parts[0] ? `${ rowData.export_parts[0].flight_no }/${ flightDate }` : '';

              return <span onClick={ () => { props.openParts(rowData) } }>{ flightNumber }</span>;
            }
          },
          { title: 'Pcs', field: 'pieces', headerStyle: { paddingRight: PADDING_RIGHT }, cellStyle: { paddingRight: PADDING_RIGHT }},
          { title: 'Wgt', field: 'weight', headerStyle: { paddingRight: PADDING_RIGHT, textAlign: 'center' }, cellStyle: { paddingRight: PADDING_RIGHT, textAlign: 'right' },
            render: (rowData: Awb) => {

              const weight: number = +(rowData.weight);

              return <span>{ weight.toFixed(1) }K</span>;
            }
          },
          { title: 'Shipper', field: 'export_metadata.shipperName' ,  headerStyle: { paddingRight: PADDING_RIGHT }, cellStyle: { paddingRight: PADDING_RIGHT }},
          { title: 'Commodity', field: 'export_metadata.comodityType', headerStyle: { paddingRight: PADDING_RIGHT }, cellStyle: { paddingRight: PADDING_RIGHT }},
          { title: 'Status', field: 'status', headerStyle: { paddingRight: PADDING_RIGHT }, cellStyle: { paddingRight: PADDING_RIGHT }, render: (rowData: Awb) => {
            if (rowData.status === 'SHIPMENT DELIVERED' || rowData.status === 'SHIPMENT PARTIALLY DELIVERED' ||
                  rowData.status === 'SHIPMENT REJECTED' || rowData.status === 'SHIPMENT PARTIALLY REJECTED') {
              return (
                <span>
                  <span>{ rowData.status }</span>
                  <span className={ style.PoD } onClick={ () => props.handleOpenPoD(rowData.code , rowData.number, rowData.version) }>PoD</span>
                </span>
              )
            }
            return (
              <span>{ rowData.status }</span>
            )
          } },
          { title: 'Action', headerStyle: { textAlign: 'center' },
            render: (rowData: Awb) => {

              return <span className={ awbActionStyle.awbActionsList } >
                <Tooltip title="Attach file">
                  <span>
                    <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachments_count }>
                      <AttachFile className={ classes.materialIcon } onClick={(events) => props.openAttachments(rowData.code, rowData.number, rowData.version) } />
                    </Badge>
                  </span>
                </Tooltip>
                { props.userRole === UserRoleType.FORWARDER &&
                  <Tooltip title="Synchronize">
                    { !rowData.edited && props.onSyncClick && rowData.allowed_ops.update_awb
                      ? <SyncIcon className={ classes.materialIcon } onClick={ () => props.onSyncClick(rowData.code, rowData.number) } />
                      : <SyncIcon className={ classes.disabledIcon } />
                    }
                  </Tooltip>
                }
                { !props.isMeEditMode &&
                  <Fragment>
                    <Tooltip title="Group in drop off order">
                      { (props.enableCartIcon(rowData.code, rowData.number) && rowData.allowed_ops.add_awb_truck) || rowData.allowed_ops.is_returned
                        ? <TruckCartIcon className={ classes.materialIcon } onClick={(events) => props.checkAirwayBillIsInTheCart(rowData.code, rowData.number, rowData.version) } />
                        : <TruckCartIcon className={ classes.disabledIcon } />
                      }
                    </Tooltip>
                    <Tooltip title="Delete from list">
                      <DeleteIcon className={ classes.materialIcon } onClick={(events) => props.deleteAwb(rowData.code, rowData.number) } />
                    </Tooltip>
                  </Fragment>
                }
              </span>;
            }
          }
        ]}

        data = { props.awbs }
          
        options = {{
          paging: false,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15,20],
          toolbar: false,
          sorting: false
        }}
      /> 
    </div>    
  )
}

const mapStateToProps = (state: any) => {
  return {
    isMeEditMode: state.manualEntryEdit.isEditMode
  }
}
  
export default withStyles(styles)(connect(mapStateToProps, {})(forwarderExport));
